import React, { useState, Suspense } from 'react';
import { Text, Spinner, SpinnerSize } from '@bechtel/gds';
import {
  TabButtonStyled,
  ProjectAdminContainerStyled,
  ProjectAdminHeaderStyled,
  ProjectAdminTabStyled,
} from '../styled';
import { UserAdminTabList } from './tab-data';
import { UserAdminTab, UserAdminTabType } from './types';
import { map } from 'lodash';
import { ErrorBoundary } from '@bechtel/client-common';
import { ManageUsers } from './users';
import { ManageRoles } from './roles';
import { ManagePermissions } from './permissions';
import { ImportUsers } from './import';
import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';

export const UserAdmin = () => {
  const [selectedTab, setSelectedTab] = useState<UserAdminTabType>(UserAdminTabType.EDIT_USERS);
  const { i18n } = useLingui();
  return (
    <ProjectAdminContainerStyled>
      <ProjectAdminHeaderStyled>
        <Text family="graphik" size="600" weight="600" color="white">
          <Trans>User Admin</Trans>
        </Text>
      </ProjectAdminHeaderStyled>
      <ProjectAdminTabStyled>
        {map(UserAdminTabList, (tabItem: UserAdminTab) => {
          return (
            <TabButtonStyled
              selected={tabItem.value === selectedTab}
              onClick={() => {
                setSelectedTab(tabItem.value);
              }}
              key={tabItem.value}
            >
              {i18n._(tabItem.label)}
            </TabButtonStyled>
          );
        })}
      </ProjectAdminTabStyled>
      {selectedTab == UserAdminTabType.EDIT_USERS && (
        <ErrorBoundary>
          <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
            <ManageUsers />
          </Suspense>
        </ErrorBoundary>
      )}
      {selectedTab == UserAdminTabType.CUSTOMIZE_ROLES && (
        <ErrorBoundary>
          <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
            <ManageRoles />
          </Suspense>
        </ErrorBoundary>
      )}
      {selectedTab == UserAdminTabType.CHANGE_PERMISSIONS && (
        <ErrorBoundary>
          <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
            <ManagePermissions />
          </Suspense>
        </ErrorBoundary>
      )}
      {selectedTab == UserAdminTabType.IMPORT_DEFAULT_USERS && (
        <ErrorBoundary>
          <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
            <ImportUsers />
          </Suspense>
        </ErrorBoundary>
      )}
    </ProjectAdminContainerStyled>
  );
};
